import LocalizedStrings from 'react-localization';

const OfferStrings = new LocalizedStrings({
  en: {
    messages: 'Messages',
  },
});

export default OfferStrings;
